import React from "react";
import Header from "../Header/Header";
import Navbar from "../Header/Navbar";
import AccountSidebar from "./AccountSidebar";

const MyProfileComponent = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="account_main  bg-[#f0ece1] justify-evenly  mt-1 flex">
        <AccountSidebar />
        <div className="balance_overview  w-[35%]  ml-3 ">
          <h2 className="font-bold">Account Details</h2>
          <div className="account_profile mt-3">
            <div className="main_account">
              <h2 className="bg-slate-400 p-1 ml-1 text-white font-bold">
                About You
              </h2>
              <ul>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">First Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Last Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] "></span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Birthday </p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Email Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Password</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">English</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
              </ul>
            </div>
            <div className="main_account mt-3">
              <h2 className="bg-slate-400 p-1 ml-1 text-white font-bold">
                About You
              </h2>
              <ul>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">First Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Last Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] "></span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Birthday </p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Email Name</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">Password</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
                <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                  <p className="text-[12px] ml-2">English</p>

                  <span className="flex justify-evenly w-[125px] text-[12px] ">
                    AB
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="main_account w-[35%] mt-[40px]">
          <h2 className="bg-slate-400 p-1 ml-1 text-white font-bold">
            About You
          </h2>
          <ul>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">First Name</p>

              <span className="flex justify-evenly w-[125px] text-[12px] ">
                AB
              </span>
            </li>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">Last Name</p>

              <span className="flex justify-evenly w-[125px] text-[12px] "></span>
            </li>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">Birthday </p>

              <span className="flex justify-evenly w-[125px] text-[12px] ">
                AB
              </span>
            </li>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">Email Name</p>

              <span className="flex justify-evenly w-[125px] text-[12px] ">
                AB
              </span>
            </li>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">Password</p>

              <span className="flex justify-evenly w-[125px] text-[12px] ">
                AB
              </span>
            </li>
            <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
              <p className="text-[12px] ml-2">English</p>

              <span className="flex justify-evenly w-[125px] text-[12px] ">
                AB
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MyProfileComponent;
